import React, { FunctionComponent } from 'react';
import clsx from 'clsx';
import { Box, Link, Typography } from '@material-ui/core';
import customisePackItemStyles from './customisePackItemStyles';
import Checkbox from '@material-ui/core/Checkbox';
import IFeature from '../../../../../../model/IFeature';
import ConfigurablePrice from '../../../../../presentational/prices/configurablePrice/ConfigurablePrice';
import Translation from '../../../../../../../common/components/translation/Translation';

export interface ICustomisePackItemProps {
  feature: IFeature;
  selected: boolean;
  onClick: (code: string) => void;
  openAccessoryPackModal: (value: boolean, optionCode: string) => void;
}

const CustomisePackItem: FunctionComponent<ICustomisePackItemProps> = ({
  feature,
  onClick,
  selected,
  openAccessoryPackModal,
}) => {
  const styles = customisePackItemStyles();

  return (
    <Box
      display="flex"
      alignItems="flex-start"
      className={clsx([styles.container, { [styles.planSelected]: selected }])}
      data-test={`option:${feature.code}`}
    >
      <Checkbox
        size={'medium'}
        checked={selected}
        onChange={() => onClick(feature.code)}
        data-test={'option:type:checkbox'}
        className={styles.checkbox}
        data-selected={`${selected}`}
      />
      <Box className={styles.titlePriceContainer}>
        <Box mr={2}>
          <Typography>{feature.name}</Typography>
          <Link
            className={styles.priceGuideToggle}
            onClick={() => openAccessoryPackModal(true, feature.code)}
            variant={'helpingText'}
            underline={'always'}
            color={'secondary'}
            data-test={'button:pack:modal'}
          >
            <Translation id="trans__configurator__customise_page_options_section__show_features_link" />
          </Link>
        </Box>
        <Box>
          <ConfigurablePrice
            prices={feature.prices}
            display={{ showOrLabel: true }}
            classes={{
              single: { priceText: styles.priceText },
              multi: {
                container: styles.multiCurrencyContainer,
                priceText: styles.multiCurrencyPriceText,
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CustomisePackItem;
